import { useState } from "react";
import axios from "axios";
import { toast, Toaster } from "sonner";
import { COMPANY } from "../lib/data";
import { trackEvent } from "../lib/analytics";
import Reveal from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initial = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

export const EnquiryForm = () => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (
      !form.first_name ||
      !form.last_name ||
      !form.email ||
      !form.phone ||
      !form.message
    ) {
      toast.error("Please fill in all required fields");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      trackEvent("enquiry_submit", {
        source: "enquiry_form",
        has_subject: !!form.subject,
      });
      toast.success("Enquiry submitted. We'll get back within 24 hours.");
      setForm(initial);
    } catch {
      trackEvent("enquiry_submit_failed", { source: "enquiry_form" });
      toast.error("Something went wrong. Please call us directly.");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full rounded-lg border border-black/10 bg-white px-4 py-3.5 text-sm text-[#1c1c1e] placeholder:text-[#bababd] focus:border-[#e85a1c] focus:outline-none transition-all duration-200";
  const label =
    "font-mono-industrial text-[10px] uppercase tracking-[0.25em] text-[#8b8b8f] mb-2 block";

  return (
    <section
      id="enquiry"
      data-testid="enquiry-section"
      className="border-b border-black/5 bg-[#f7f7f5] py-24"
    >
      <Toaster position="top-right" theme="light" />
      <div className="mx-auto grid max-w-[1400px] gap-16 px-6 md:grid-cols-12 lg:px-10">
        <Reveal className="md:col-span-5">
          <div className="font-mono-industrial text-[10px] uppercase tracking-[0.3em] text-[#e85a1c]">
            / Send an enquiry
          </div>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[0.92] tracking-tighter text-[#1c1c1e] md:text-6xl">
            Let&rsquo;s talk
            <br />
            <span className="text-[#e85a1c]">tonnage.</span>
          </h2>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-[#4a4a4e]">
            Share your project and brand preferences. Our team will share
            the most competitive quote within 24 hours.
          </p>
          <div className="mt-10 space-y-3 border-t border-black/10 pt-8 text-[12px] uppercase tracking-[0.15em] text-[#8b8b8f]">
            <div>Tel · <span className="font-mono-industrial text-[#1c1c1e]">{COMPANY.phone}</span></div>
            <div>Mail · <span className="font-mono-industrial text-[#1c1c1e] normal-case">{COMPANY.email}</span></div>
            <div>Loc · <span className="text-[#1c1c1e]">{COMPANY.address}</span></div>
          </div>
        </Reveal>

        <Reveal delay={120} className="md:col-span-7">
          <form
            onSubmit={submit}
            data-testid="enquiry-form"
            className="rounded-2xl border border-black/5 bg-white p-6 shadow-lux md:p-8"
          >
            <div className="grid gap-5 md:grid-cols-2">
              <div>
                <label className={label}>First Name *</label>
                <input data-testid="enquiry-first-name" name="first_name" value={form.first_name} onChange={onChange} className={field} placeholder="Gaurav" />
              </div>
              <div>
                <label className={label}>Last Name *</label>
                <input data-testid="enquiry-last-name" name="last_name" value={form.last_name} onChange={onChange} className={field} placeholder="Sharma" />
              </div>
              <div>
                <label className={label}>Email *</label>
                <input data-testid="enquiry-email" name="email" type="email" value={form.email} onChange={onChange} className={field} placeholder="you@site.com" />
              </div>
              <div>
                <label className={label}>Phone *</label>
                <input data-testid="enquiry-phone" name="phone" value={form.phone} onChange={onChange} className={field} placeholder="+91 98XXXXXXXX" />
              </div>
              <div className="md:col-span-2">
                <label className={label}>Subject</label>
                <input data-testid="enquiry-subject" name="subject" value={form.subject} onChange={onChange} className={field} placeholder="Enquiry for 20 MT — residential project" />
              </div>
              <div className="md:col-span-2">
                <label className={label}>Message *</label>
                <textarea data-testid="enquiry-message" name="message" rows={5} value={form.message} onChange={onChange} className={field} placeholder="Tell us about your requirement, preferred brand, quantity and site location." />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="enquiry-submit-btn"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#e85a1c] px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-[#c64812] hover:shadow-orange disabled:opacity-60"
            >
              {loading ? "Submitting…" : "Submit Enquiry →"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default EnquiryForm;
